import React from "react";
import PictureUploadField from "../../PictureUploadField/PictureUploadField";
import qfStyles from "../QuickFormComponent.module.css";
import i18n from "../../../Services/i18n";
import RichEditor from "../../RichEditor/RichEditor";
import { addToast } from "../../../Services/toastService";

class UserServiceQuickForm extends React.Component {
  constructor(props) {
    super(props);
    this.pictureUploadFieldRef = React.createRef();
    this.state = {
      title: "",
      description: "",
      isForClients: true,
      isForHorses: true,
    };
  }

  handleNameChange = (e) => {
    this.setState({ title: e.target.value });
  };

  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked });
  };

  getFormData = () => {
    const pictureFieldData = this.pictureUploadFieldRef.current.getData();
    return {
      title: this.state.title,
      description: this.state.description,
      defaultImageId: pictureFieldData.fileId,
      isForClients: this.state.isForClients,
      isForHorses: this.state.isForHorses,
    };
  };

  isDirty = () => {
    const pictureFieldData = this.pictureUploadFieldRef.current?.getData?.();
    const hasPicture = !!pictureFieldData?.fileId;

    const hasTextValue = Object.values(this.state).some((value) => {
      if (typeof value !== "string") return false;
      return value.trim() !== "";
    });

    return hasTextValue || hasPicture;
  };

  validate = () => {
    if (this.state.title === "") {
      addToast(
        i18n.t("UserServiceForm.validation.NameRequired"),
        "userServiceFormValidation",
        "ERROR",
      );
      return false;
    }

    if (this.state.description.length > 40000) {
      addToast(
        i18n.t("ClientForm.Validation.InvalidDescriptionLen"),
        "clientFormValidationEmail",
        "ERROR",
      );
      return false;
    }

    return true;
  };

  render() {
    return (
      <div className={qfStyles.container}>
        <div className={qfStyles.quickFormLeft}>
          <label className={qfStyles.quickFormLabel}>
            {i18n.t("UserServiceQuickForm.FieldTitle")}
            <input
              type="text"
              maxLength={200}
              className={qfStyles.quickFormInput}
              value={this.state.title}
              onChange={this.handleNameChange}
            />
          </label>

          <div className={qfStyles.section}>
            <label className={qfStyles.quickFormLabel}>
              {i18n.t("UserServiceQuickForm.FieldAvailability")}
            </label>
            <div className={qfStyles.checkboxGroup} style={{ marginBottom: "20px" }}>
              <label className={qfStyles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="isForClients"
                  checked={this.state.isForClients}
                  onChange={this.handleCheckboxChange}
                />
                {i18n.t("UserServiceQuickForm.FieldAvailability.Clients")}
              </label>
              <label className={qfStyles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="isForHorses"
                  checked={this.state.isForHorses}
                  onChange={this.handleCheckboxChange}
                />
                {i18n.t("UserServiceQuickForm.FieldAvailability.Horses")}
              </label>
            </div>
            <label className={qfStyles.quickFormLabel}>
              {i18n.t("UserServiceQuickForm.FieldDescription")}
            </label>

            <RichEditor
              controlled
              value={this.state.description}
              onChange={(html) => {
                this.setState({ description: html });
              }}
              placeholder={""}
              height={300}
              showEmoji
              showTextColor
              showFontSize
              showBold
              showItalic
              showUnderline
              showStrikethrough
            />
          </div>
        </div>

        <div className={qfStyles.quickFormRight}>
          <PictureUploadField ref={this.pictureUploadFieldRef} />
        </div>
      </div>
    );
  }
}

export default UserServiceQuickForm;
